module.exports = __webpack_public_path__ + "img/abbvie.762b2ff6.jpg";